import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      category: 'Orders & Shipping',
      items: [
        {
          question: 'How do I place an order?',
          answer: 'You can place an order by browsing our website, adding items to your cart, and proceeding to checkout. We accept various payment methods for your convenience.'
        },
        {
          question: 'What are your shipping options?',
          answer: 'We offer standard shipping (5-7 business days), express shipping (2-3 business days), and overnight delivery for urgent orders. Shipping costs vary based on location and order value.'
        },
        {
          question: 'Do you ship internationally?',
          answer: 'Currently, we ship within India. International shipping may be available for select products. Please contact our sales team for international orders.'
        }
      ]
    },
    {
      category: 'Products & Quality',
      items: [
        {
          question: 'Are your products FDA approved?',
          answer: 'All our dental products meet or exceed industry standards and are sourced from reputable manufacturers. We ensure compliance with relevant regulatory requirements.'
        },
        {
          question: 'Do you offer product warranties?',
          answer: 'Most of our products come with manufacturer warranties. Warranty terms vary by product. Please check the product description or contact us for specific warranty information.'
        },
        {
          question: 'How do I know which products are right for me?',
          answer: 'Our product specialists are available to help you choose the right products for your needs. You can contact us or consult with your dental professional for recommendations.'
        }
      ]
    },
    {
      category: 'Payments & Refunds',
      items: [
        {
          question: 'What payment methods do you accept?',
          answer: 'We accept credit/debit cards, net banking, UPI, and cash on delivery for eligible orders. All payments are processed securely through encrypted channels.'
        },
        {
          question: 'What is your refund policy?',
          answer: 'We offer refunds within 30 days of purchase for unused products in original packaging. Please see our detailed refund policy for complete terms and conditions.'
        },
        {
          question: 'How long does it take to process a refund?',
          answer: 'Refunds are typically processed within 5-7 business days after we receive the returned item. The time for the refund to appear in your account depends on your payment method.'
        }
      ]
    },
    {
      category: 'Account & Support',
      items: [
        {
          question: 'How do I create an account?',
          answer: 'Click on the "Sign Up" link in the top right corner of our website and follow the registration process. Creating an account allows you to track orders, save favorites, and enjoy personalized recommendations.'
        },
        {
          question: 'How can I contact customer support?',
          answer: 'You can reach our customer support team via phone (+91 70931 34343), email (support@dentalstores.in), or through our live chat feature during business hours.'
        },
        {
          question: 'What are your business hours?',
          answer: 'Our customer support is available Monday through Saturday from 10:30 AM to 7:00 PM IST. Emergency support is available 24/7 for urgent matters.'
        }
      ]
    }
  ];

  let itemIndex = 0;

  return (
    <>
      <Helmet>
        <title>FAQ - Dental Stores</title>
        <meta name="description" content="Find answers to frequently asked questions about Dental Stores products, orders, shipping, and more." />
      </Helmet>
      <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '600', marginBottom: '20px', color: '#30363C' }}>Frequently Asked Questions</h1>

        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>{section.category}</h2>
            {section.items.map((item, index) => {
              const currentIndex = itemIndex++;
              return (
                <div key={index} style={{ marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                  <div
                    style={{
                      padding: '15px',
                      cursor: 'pointer',
                      backgroundColor: '#f9f9f9',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                    onClick={() => toggleItem(currentIndex)}
                  >
                    <h3 style={{ fontSize: '18px', fontWeight: '500', margin: 0, color: '#30363C' }}>{item.question}</h3>
                    <span style={{ fontSize: '18px', color: '#30363C' }}>{openItems[currentIndex] ? '−' : '+'}</span>
                  </div>
                  {openItems[currentIndex] && (
                    <div style={{
                      padding: '15px',
                      backgroundColor: '#fff',
                      borderTop: '1px solid #ddd',
                      transition: 'all 0.3s ease'
                    }}>
                      <p style={{ margin: 0 }}>{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}

        <h2 style={{ fontSize: '22px', fontWeight: '600', marginTop: '30px', marginBottom: '15px', color: '#30363C' }}>Still Have Questions?</h2>
        <p>
          If you couldn't find the answer to your question here, please don't hesitate to contact us.
          Our friendly support team is always ready to help!
        </p>

        <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', marginTop: '30px' }}>
          <h3>Contact Information</h3>
          <p><strong>Phone:</strong> +91 70931 34343</p>
          <p><strong>Email:</strong> support@dentalstores.in</p>
          <p><strong>Business Hours:</strong> Mon-Sat 10:30 AM - 7:00 PM IST</p>
        </div>
      </div>
    </>
  );
};

export default FAQ;